import React from 'react'
import { Modal } from 'react-responsive-modal'

// Styles
import './styles.scss'

// Components
import Loading from '../Loading'

// Icons
import IconClose from '../ModalFiles/images/iconClose'

export default ({
  modal,
  type,
  isLoading,
  onClose,
  onChangeProfileRole,
}: {
  modal: boolean
  type: string
  isLoading: boolean
  onClose: () => void
  onChangeProfileRole: () => void
}) => {
  const modalStyles = {
    root: {
      zIndex: 99999,
    },
    overlay: {
      background: 'rgba(0, 0, 0, 0.4)',
    },
    modal: {
      width: 565,
      borderRadius: 50,
      padding: '50px 0 44px',
      margin: '2em',
      boxShadow: 'unset',
      overflow: 'unset',
      outline: 0,
    },
  }

  return (
    <Modal
      open={modal}
      showCloseIcon={false}
      onClose={onClose}
      styles={modalStyles}
      center={true}
    >
      <div className={'modal-change-role'}>
        <button className={'modal__close'} onClick={onClose}>
          <IconClose />
        </button>
        <span className={'modal-change-role__title'}>
          {type === 'teacher' ? 'Вы учитель?' : 'Вы ученик?'}
        </span>
        <button
          onClick={onChangeProfileRole}
          className={'modal-change-role__button yes'}
        >
          {isLoading ? (
            <Loading
              style={{ margin: 0 }}
              width={40}
              height={40}
              color={'#219321'}
            />
          ) : (
            <span>Да</span>
          )}
        </button>
        <button onClick={onClose} className={'modal-change-role__button'}>
          <span>Нет</span>
        </button>
      </div>
    </Modal>
  )
}
